import { radialEffect } from '../animations/radialEffect';
import type { ButtonThemePalette } from '../Button.types';
import { getLinearGradient } from '../utils/getLinearGradient.util';

export const primary = {
  default: ({ button }: ButtonThemePalette): string => `
    background-color: ${button.background.primary.base};
    color: ${button.text.primary.base};

    &:hover {
      background-color: ${button.background.primary.hover};
    }

    ${radialEffect.active(button.background.primary.after)}
  `,
  withLinearGradient: ({ button }: ButtonThemePalette): string => `
    ${getLinearGradient({ button })}
    color: ${button.text.secondary.base};

    ${radialEffect.active(button.background.primary.after)}
  `,
};
